// Texty procházení výprodeje (saleBrowse.js, saleBrowseModel.js): dlaždice
// kořenových kategorií, čipy podkategorií, filtr a řazení z vlastního indexu
// na stránce akční nabídky (plátno docs/design/2026-10-07-vyprodej-prochazeni/).
import { plural } from '../plural.js';

const NBSP = '\u00A0';
const pct = (n) => n + NBSP + '%';
const products = (n) => plural(n, ['produkt', 'produkty', 'produktů']);

export default {
  // Stav výřezu je v adrese (`/slevoakce/?kategorie=zahrada&sleva=30`), jména
  // parametrů i hodnoty řazení proto patří k jazyku shopu.
  params: {
    cat: 'kategorie',
    sub: 'podkategorie',
    disc: 'sleva',
    price: 'cena',
    brand: 'znacka',
    last: 'posledni-kusy',
    clearance: 'vyprodej',
    order: 'razeni',
  },
  orderSlugs: {
    bestseller: 'nejprodavanejsi',
    discount: 'nejvetsi-sleva',
    price_asc: 'nejlevnejsi',
    price_desc: 'nejdrazsi',
  },
  sortLabels: {
    bestseller: 'Nejprodávanější',
    discount: 'Největší sleva',
    price_asc: 'Nejlevnější',
    price_desc: 'Nejdražší',
  },

  tilesLabel: 'Kategorie ve výprodeji',
  /** „129 produktů" pod názvem dlaždice */
  count: (n) => n + ' ' + products(n),
  // Čip „Vše v Zahradě" = celý vybraný kořen. Šestý pád názvu kategorie z dat
  // šablona neumí, proto tabulka po kořenech manifestu (`catalog.roots`).
  allIn: {
    garden: 'Vše v Zahradě',
    build: 'Vše ve Stavbě a domě',
    workshop: 'Vše v Dílně',
    home: 'Vše v Domácnosti',
    kids: 'Vše v Dětských hřištích',
    car: 'Vše v Autodoplňcích',
    xmas: 'Vše na Vánoce',
    ppe: 'Vše v Ochranných pomůckách',
    solar: 'Vše ve Fotovoltaice',
  },
  allFallback: 'Vše',
  chipsLabel: 'Podkategorie',
  /** „Další (17)" — čipy, které se nevešly do řádku */
  chipsMore: (n) => 'Další (' + n + ')',
  chipsLess: 'Méně',

  // Filtr
  discount: 'Sleva',
  /** „od 20 %" */
  discFrom: (n) => 'od ' + pct(n),
  price: 'Cena',
  priceMin: 'Cena od',
  priceMax: 'Cena do',
  /** čip aktivního cenového filtru „100 Kč – 500 Kč" */
  priceRange: (from, to) => from + ' – ' + to,
  brand: 'Značka',
  availability: 'Dostupnost',
  lastPieces: 'Poslední kusy',

  // nativní název příznaku akční nabídky (štítek karty mimo kampaň)
  flagAction: 'Slevoakce',

  // Žlutá dlaždice výprodeje skladu (filtruje na místě), claim z kampaně
  clearanceTitle: 'Výprodej skladu',
  /** „až −30 %" */
  clearanceClaim: (n) => 'až −' + pct(n),

  // Načítání po dávkách
  more: (n) => 'Načíst ' + (n < 5 ? 'další ' : 'dalších ') + n + ' ' + products(n),
  shown: (shown, total) => 'Zobrazeno ' + shown + ' z ' + total + ' ' + products(total),

  // Výběr bez výsledku
  emptyTitle: 'Výběru neodpovídá žádný produkt',
  emptyText: 'Zkuste zrušit některý z filtrů nebo vybrat jinou kategorii.',
  emptyCta: 'Zrušit filtry',

  /** GA4 `item_list_name` výřezu („Říjnový výprodej – Zahrada") */
  listName: (sale, slice) => (slice ? sale + ' – ' + slice : sale),
};
